import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initAnalytics } from '@/config/firebase';
import { App } from './App';
import '@/styles/global.css';

/**
 * Entry point — mirrors Flutter's main() in main.dart.
 *
 * Sequence:
 *   1. Initialize Firebase Analytics (if supported)
 *   2. Mount <App /> — which triggers TenantProvider → AuthProvider → Router
 */
async function bootstrap() {
  await initAnalytics();

  const root = document.getElementById('root');
  if (!root) throw new Error('Root element not found');

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

bootstrap();
